import React, { useEffect } from 'react'
import {motion} from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/About.css'
import xm1 from '../assets/images/aboutmain.png'
import ab1 from '../assets/images/ab1.png'
import ab2 from '../assets/images/ab2.png'
import ab3 from '../assets/images/ab3.png'
import ab4 from '../assets/images/ab4.png'
import ab12 from '../assets/images/aba1.png'
import ab13 from '../assets/images/aba2.png'
import ab14 from '../assets/images/aba3.png'
import ab15 from '../assets/images/aba4.png'
import ab16 from '../assets/images/aba5.png'
import ab17 from '../assets/images/aba6.png'
import ab18 from '../assets/images/aba7.png'
import ab19 from '../assets/images/aba8.png'
import star from '../assets/images/star.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'


const About = () => {
  useEffect(()=>{
    AOS.init();
   
  })

  return (
    <div>
         <section className="ab_main">
        <div className="ab_main_sec">
          <h1>
     About  
                 <span style={{ color: "#EEBD2B" }}>            Xceed
</span>

        </h1>

          <p>Operate your business from a professional environment designed for credibility, focus, and flexibility. </p>

           <p>We're redefining what it means to work. Premium spaces <br />
designed for ambitious minds who demand excellence.</p>
        
              <button> Schedule a Tour    </button> &nbsp;
          <button style={{ background: "#0D0D0D", color: "white", opacity: 1 }}>
            View Pricing
          </button>
    
        </div>
      </section>

    
    <section style={{background:"#EEBD2B"}}>
      <div className='ab__div2'>
        <div className='ab__row1'>
          <div className='ab__col1'><h2>500+</h2><p>Active Members</p></div>
          <div className='ab__col1'><h2>15K</h2><p>Sq Ft Space</p></div>
          <div className='ab__col1'><h2>24/7</h2><p>Access Available</p></div>
          <div className='ab__col1'><h2>98%</h2><p>Satisfaction Rate</p></div>
        </div>
      </div>
    </section>
    

    <section className="phil">
      <div className="phil__container">
        <div className="phil__grid">
          {/* LEFT: image mosaic */}
          <div className="phil__mosaic" aria-label="Workspace image collage">
            <div className="phil__tile phil__tile--a">
              <img src={ab1} alt="Workspace lounge" />
            </div>
            <div className="phil__tile phil__tile--b">
              <img src={ab2} alt="Private office" />
            </div>
            <div className="phil__tile phil__tile--c">
              <img src={ab3} alt="Conference room" />
            </div>
            <div className="phil__tile phil__tile--d">
              <img src={ab4} alt="Desk setup" />
            </div>
          </div>

          {/* RIGHT: content */}
          <div className="phil__content">
            <p className="phil__kicker">OUR PHILOSOPHY</p>

            <h2 className="phil__title">
              Environment Shapes <span>Perception</span>
            </h2>

            <p className="phil__lead">
              Where you work affects how clients see you.
              <br />
              It affects how your team performs.
              <br />
              It affects how you think.
            </p>

            <p className="phil__text">
              Xceed Office locations are carefully selected inside Class A
              buildings in Houston’s most recognized business districts. We
              prioritize prestige, accessibility, and long-term stability over
              trend-driven design.
            </p>

            <p className="phil__text">This is intentional.</p>

            <div className="phil__rule" />

            <div className="phil__since">Since 2018</div>
          </div>
        </div>
      </div>
    </section>

<section className="lead">
  <div className="lead__container">
    <header className="lead__header">
      <h2 className="lead__title">
        Meet Our <span>Leadership</span>
      </h2>
    </header>

    <div className="lead__grid" role="list">
      <article className="leadCard" role="listitem">
        <div className="leadCard__imgWrap">
          <img src={ab1} alt="Executive Positioning" />
        </div>
        <div className="leadCard__overlay">
          <h3 className="leadCard__title">Executive Positioning</h3>
          <div className="leadCard__rule" />
          <p className="leadCard__text">
            We operate inside premier business corridors such as Uptown Houston and the
            Post Oak district, ensuring that your address carries weight.
          </p>
        </div>
      </article>

      <article className="leadCard" role="listitem">
        <div className="leadCard__imgWrap">
          <img src={ab2} alt="Structured Support" />
        </div>
        <div className="leadCard__overlay">
          <h3 className="leadCard__title">Structured Support</h3>
          <div className="leadCard__rule" />
          <p className="leadCard__text">
            Professional front desk reception, mail handling, call answering, and booking
            systems are built to support your daily operations.
          </p>
        </div>
      </article>

      <article className="leadCard" role="listitem">
        <div className="leadCard__imgWrap">
          <img src={ab3} alt="Flexible Without Compromise" />
        </div>
        <div className="leadCard__overlay">
          <h3 className="leadCard__title">Flexible Without Compromise</h3>
          <div className="leadCard__rule" />
          <p className="leadCard__text">
            Traditional leases require long commitments. Xceed membership removes that
            burden while maintaining executive presence.
          </p>
        </div>
      </article>

      <article className="leadCard" role="listitem">
        <div className="leadCard__imgWrap">
          <img src={ab4} alt="Designed for Growth" />
        </div>
        <div className="leadCard__overlay">
          <h3 className="leadCard__title">Designed for Growth</h3>
          <div className="leadCard__rule" />
          <p className="leadCard__text">
            Whether starting with a virtual office or expanding into a dedicated private
            suite, our solutions scale with your business.
          </p>
        </div>
      </article>
    </div>

    {/* optional bottom pill/indicator like screenshot */}

  </div>
</section>
<br /><br /><br />

    <section >
      <div className='ab__div5'>
        <div className='ab__row5'>
          <div className='ab__col5'>
            <h3>Why Choose Us</h3>
            <h2>Included Amenities</h2>
          </div>
          <div className='ab__col5'>
            <p>Everything you need to do your best work, included with every
membership.</p>
          </div>
        </div>
<br />

    <div className='ab__row6'>
      <div className='ab__col6'>
<img src={ab12} alt="" />
        <h3>High-Speed WiFi</h3>
        <p>Enterprise-grade internet with redundan
connections.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab13} alt="" />
   <h3>Pantry</h3>
        <p>Fully stocked kitchen with premium coffee and
snacks.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab14} alt="" />
       <h3>Printing</h3>
        <p>Professional printing and scanning equipment.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab15} alt="" />
        <h3>Lounge</h3>
        <p>Comfortable spaces for relaxation and networking.</p>
      </div>

    </div>
    <div className='ab__row6'>
      <div className='ab__col6'>
        <img src={ab16} alt="" />
        <h3>Helpdesk</h3>
        <p>On-site support team available during busines
hours.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab17} alt="" />
        <h3>Prayer Rooms</h3>
        <p>Private, quiet spaces for meditation and prayer.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab18} alt="" />
        <h3>Great Value</h3>
        <p>Flexible plans designed for every budget.</p>
      </div>
      <div className='ab__col6'>
        <img src={ab19} alt="" />
        <h3>Beverages</h3>
        <p>Unlimited tea and coffee throughout your
workday.</p>
      </div>

    </div>


      </div>
    </section>
    <br /><br />
     <br /><br />
 <section className='location__lst'>
    <div className='location__div'>
        <h2>Ready to Elevate Your Work?</h2>
        <p>Join our community of innovators and experience the <br /> difference that a premium
workspace makes.</p>
<button>Get Started Today</button> <button style={{background:"black",color:"white"}}>Contact Us</button>
    </div>
 </section>
    </div>
  )
}

export default About